import React from 'react';
import {
  AnalyticsIcon,
  BrandsIcon,
  CampaignIcon,
  DashboardIcon,
  DistributorsIcon,
  DrawIcon,
  InventoryIcon,
  OrdersIcon,
  ProductsIcon,
  ProfileIcon,
  QRCodeIcon,
  RetailersIcon,
  SettingsIcon,
  UserManagementIcon,
} from '@/components/Icons';

// Icon mapping for custom SVG icons
// Use 'custom-' prefix to avoid conflicts with Ant Design icons
export const iconMap: Record<string, React.FC<any>> = {
  'custom-dashboard': DashboardIcon,
  'custom-qrcode': QRCodeIcon,
  'custom-campaign': CampaignIcon,
  'custom-trophy': DrawIcon,
  'custom-shop': RetailersIcon,
  'custom-truck': DistributorsIcon,
  'custom-user': ProfileIcon,
  'custom-barChart': AnalyticsIcon,
  'custom-fileText': OrdersIcon,
  'custom-team': UserManagementIcon,
  'custom-settings': SettingsIcon,
  'custom-inventory': InventoryIcon,
  'custom-product': ProductsIcon,
  'custom-brands': BrandsIcon,
};
